<template>
    <div style="padding: 0 12px; padding-bottom: 32px;">
        <swiper style="height: 206px; border-radius: 12px; overflow: hidden;" :options="swiperOption" role="tablist" ref="swiper">
            <swiper-slide v-for="each, i in spotlights" :key="i" style="width: 100%; height: 100%; position: relative; border-radius: 12px; background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.8) 100%);" role="tab">
                <img style="width: 100%; height: 100%; position: absolute; z-index: -1; object-fit: cover;" :src="$resourcePath + each.image_path" alt="">
                <div @click="showInterviewDetail(each, i)" style="position: relative; padding: 20px; height: 100%; display: flex; flex-direction: column; z-index: 1; justify-content: end;">
                    <div style="color: #fff; font-size: 20px; font-weight: 700; line-height: 32px; margin-bottom: 4px; word-break: break-all;">{{ each.title }}</div>
                    <div style="color: #bbb; font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.name }}</div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; top: 20px; height: 20px; text-align: right; padding-right: 20px; z-index: 10; display:inline-block;"></div>
        </swiper>
    </div>

</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    name: "SwipedSelectedSpotLight",
    components: { swiper, swiperSlide },
    props: {
        spotlights: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            swiperOption: {
                // slidesPerView: 'auto',
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                autoplay: {
                    delay: 5000
                },
                curIndex: 0,
            },
        }
    },
    methods: {
        showInterviewDetail(detail) {
            this.$Util.sendEventClick('홈_스포트라이트_배너_하단', true);
            this.$GlobalStore.addModal('InterviewDetail', { spotlightIdx: detail.idx, isFromHome: true })
        },
    }
}
</script>

<style scoped>
.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
}
</style>